import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import useAppStore from './store';
import './index.css';

// Hydrate the persisted session BEFORE the router mounts (T8.5) so route
// guards start from a resolved auth state instead of flashing /login on refresh.
useAppStore.getState().hydrateSession();

createRoot(document.getElementById('root')).render(
<StrictMode>
    <App />
</StrictMode>
);
